//src/pages/REG/REG200F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import style from "./REG200F1.module.scss";
import Modal from "components/Modal/Modal";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import { dateToYMD, ymdToDate } from './REGComUtil'; //
import dayjs from 'dayjs';
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import Icon from "../../components/Icon/Icon";
import DataGrid from "../../components/DataGrid/DataGrid";

import {MenuContext} from "pages/COM/COM001L1";



// 페이지 시작
const REG200F1 = ({navBar: NavBar, isActive}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기

    const { addPage_manual } = useContext(MenuContext);
    const [comHsptObj, setComHsptObj] = useState([]);


    //검색 조건
    const [schUserNm, setSchUserNm] = useState('');
    const [isReadHospital, setIsReadHospital] = useState(true);


    //사용자리스트
    const [rows_NoticeList, setRows_NoticeList] = useState([]);
    const searchObj = [
        { name:"hsptCd", value: userInfo.hsptCd},
        { name:"subjectCd", value: ''},
        { name:"fromDt", value: ''},
        { name:"toDt", value: ''},
        { name:"initial", value: ''}

    ];
    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        // { key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        // { key: 'titlNm',         name: 'Subject',     width: '10%', cellClass: 'align_left' },
        { key: 'subjectCd',     name: 'Subject',  width: '5%' },
        { key: 'acquisitionDt', name: '동의서취득일',  width: '6%' },
        { key: 'age',        name: '나이',    width: '3%'},
        { key: 'sexNm',      name: '성별',  width: '3%'},
        { key: 'initial',    name: 'initial',  width: '5%'},
        { key: 'task1Stat',  name: 'Admission',  width: '5%'},
        { key: 'task12Stat', name: 'Lab data',  width: '5%'},
        { key: 'task2Stat',  name: 'CAG',  width: '5%'},
        { key: 'task3Stat',  name: '1st Lesion',  width: '5%'},
        { key: 'task4Stat',  name: '2nd Lesion',  width: '5%'},
        { key: 'task5Stat',  name: '3rd Lesion',  width: '5%'},
        { key: 'task6Stat',  name: '4th Lesion',  width: '5%'},
        { key: 'task7Stat',  name: 'Discharge',  width: '5%'},
        { key: 'task8Stat',  name: '1M FU',  width: '5%'},
        { key: 'task9Stat',  name: '6M FU',  width: '5%'},
        { key: 'task10Stat', name: '12M FU',  width: '5%'},
        { key: 'task11Stat', name: 'FU Angiography',  width: '7%'},
        { key: 'task13Stat', name: 'Clinical Event',  width: '6%'},
        { key: 'task99Stat', name: 'End',  width: '5%'},
        { key: 'queryStat',  name: 'Query',  width: '5%'}
    ];


    const [inputData, setInputData]  = useState(searchObj);


    const [isComCodeReady, setIsComCodeReady] = useState(false);
    //form load
    useEffect(() => {
        const fetchComCode = async () => {
            //console.log('공통코드 조회 시작');
            await getComDtlsData(); // 비동기 처리 가정
            //console.log('공통코드 조회 완료');
            setIsComCodeReady(true);
            if(userInfo.roleId==="300001"){
                setIsReadHospital(false);
            }
        };
        fetchComCode();
    }, []);
    useEffect(() => {
        if (isComCodeReady && isActive) {
            //console.log('공통코드 준비 + 탭 활성화 → subject 조회');
            getSubjectList();
        }
    }, [isComCodeReady, isActive]);


    //데이터 get, set
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };

    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }

    const getItemLabel = (getName) =>{
        return inputData.find(item => item.name === getName).label;
    }


//확인 버튼 클릭
    const handleClick_search = (e) => {
        getSubjectList();
    }

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };

    // 데이터 더블클릭
    const handleDoubleClick_DataGrid_row = (e) => {

       const reStatYn = 'Y';
       const param = {mstId:e.row.mstId, hsptCd: e.row.hsptCd, colKey: e.column.key};

       const selMenu = {
         menuCd:"REG300F1",
         menuId:"030003",
         menuPos:"연구 > edit",
         menuTl:"edit"
       }
       addPage_manual(selMenu, param, reStatYn); //화면 열기 - 변경 필요 현 하드 코딩되어 있음.
    }



    /* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setItemValue("hsptCd", userInfo.hsptCd);
    }
 
    /* 데이터 조회  
    * 
    * */    
    async function getSubjectList(){
        //메인 데이터 조회
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        const res = await postData("/REW/getSubjectList", getParam);

        // stat 값을 변환하는 재사용 가능한 함수
        const convertStatValue = (value) => {
            switch (value) {
                case 'A':
                    return '🔴';
                case 'B':
                    return '🔵';
                case 'C':
                    return '🟢';
                default:
                    return '';
            }
        };

        const updatedList = res.map(row => {
            return {
                ...row,
                task1Stat: convertStatValue(row.task1Stat),
                task2Stat: convertStatValue(row.task2Stat),
                task3Stat: convertStatValue(row.task3Stat),
                task4Stat: convertStatValue(row.task4Stat),
                task5Stat: convertStatValue(row.task5Stat),
                task6Stat: convertStatValue(row.task6Stat),
                task7Stat: convertStatValue(row.task7Stat),
                task8Stat: convertStatValue(row.task8Stat),
                task9Stat: convertStatValue(row.task9Stat),
                task10Stat: convertStatValue(row.task10Stat),
                task11Stat: convertStatValue(row.task11Stat),
                task12Stat: convertStatValue(row.task12Stat),
                task13Stat: convertStatValue(row.task13Stat),
                task99Stat: convertStatValue(row.task99Stat)
            };
        });
        setRows_subjectList(updatedList);

        //setRows_subjectList(res);
    }
    
    
    return (
        <>
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}
                            onClick={() => handleClick_search()}>
                        조회
                    </Button>
                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr style={{alignContent: "center"}}>
                        <td className={style.content_typ1} style={{width: "5%"}}>
                            연구기관
                        </td>
                        <td>
                            <SelectBox options={comHsptObj} value={getItemValue("hsptCd")}
                                       onChange={(value) => setItemValue("hsptCd", value)}
                                       valueKey="comnDtlsCd" labelKey="detlCdNm"
                                       isAllExpr={false} isDisabled={isReadHospital}
                            />
                        </td>
                        <td className={style.content_typ1} style={{width: "7%"}}> 동의서 취득일</td>
                        <td style={{width: "25%"}}>
                            <div className={style.content_typ2}>
                                <DatePicker selDate={ymdToDate(getItemValue('fromDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('fromDt', dateToYMD(date))}/>
                                {insertSpace(2)}~{insertSpace(2)}
                                <DatePicker selDate={ymdToDate(getItemValue('toDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('toDt', dateToYMD(date))}/>
                            </div>
                        </td>
                        <td className={style.content_typ1} style={{width: "6%"}}> Subject No.</td>
                        <td style={{width: "12%"}}>
                            <InputUnitText type={"text"} value={getItemValue('subjectCd')} unit={""}
                                           onChange={(value) => setItemValue('subjectCd', value)}/>
                        </td>
                        <td className={style.content_typ1} style={{width: "4%"}}> Initial</td>
                        <td>
                            <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}
                                           onChange={(value) => setItemValue('initial', value.toString().toUpperCase())}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>

            <div className={styleCom.root_wrap} style={{height: "100%", overflowY: "scroll"}}>
                <div className={styleCom.title_wrap}>
                    <h3>Subject List</h3>
                </div>
                <div style={{marginTop: "10px"}}>
                    <DataGrid
                        cols={cols_subjectList}
                        rows={rows_subjectList}
                        rowHeight={37}
                        onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>
            </div>


        </main>
        </>

    )
        ;
};


export default REG200F1;
